<template>
  <div class="calendar" style="padding: 0">
    <!--<pre class="mini-pre">{{ user_events_and_optimizer_events_merged }}</pre>-->
    <calendar-top-bar
      ref="calendarTopBar"
      @action="onTriggerCalendarEvent"
      @save="onSaveViewSettings">
    </calendar-top-bar>
    <full-calendar
      ref="calendar"
      :events="user_events_and_optimizer_events_merged"
      :config="calendar_config"
      :editable="calendar_config.editable"
      :selectable="calendar_config.selectable"
      @view-render="onRender"
      @event-selected="onEventSelect"
      @event-resize="onEventResize"
      @event-drop="onEventResize"
      @event-created="onEventCreate"
      @event-render="eventRender"
      @event-destroy="eventDestroy"
      @event-mouseover="onEventMouseOver"
      @event-mouseout="onEventMouseOut"
      v-loading="optimization_running"
      :element-loading-text="calendar_loading_text"
      ></full-calendar>

    <!--<div v-if="SHOW_DEBUG" >
      <pre>calendar_config: {{calendar_config}}</pre>
      <pre>user_events_and_optimizer_events_merged: {{user_events_and_optimizer_events_merged}}</pre>
      <pre>effort_list_all: {{effort_list_all}}</pre>
    </div>-->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import FullCalendar from './Elements/FullCalendar'
import moment from '@/moment-gp.js';
import $ from 'jquery'
import CalendarTopBar from '@/components/CalendarPage/Elements/CalendarTopBar'
import CalendarTooltipMixin from './Elements/CalendarTooltip.mixin.js'
import { ENABLE_PRE_RENDERED_POPOVERS, ENABLE_POPOVERS_FOR_SOURCE } from '@/features'
//import util from '@/util'

// TODO: Sehr verwirrend, wenn nicht klar zu welcher TSC ein delete block gehört
//       Es wäre besser wenn jede column einer TSC entspricht

export default {
  mixins: [CalendarTooltipMixin],
  data: () => ({
    height: 900
    // optimizer_results: require('@/assets/action_plan_results.json').plan,
  }),
  watch: {
    $route (to, from) {
      /* After a route update the calendar needs a refresh! */
      console.log('***** refresh calendar 1 *****', to.path);
      if ( to.path === '/calendar' ) {
        // TODO: move to function
        this.$nextTick(() => {
          /* 'render' does not work, this WORKAROUND does for some reason */
          try {
            $('.fc-now-indicator-line')[0].scrollIntoView(true, {
            behavior: 'auto',
            block: 'start'
          })
          } catch (e) {
            console.warn('Could not scroll to calendar position');
          }

          /*
          TODO: Check if still necessary
          $(this.$refs.calendar.$el).fullCalendar('today');
          $(this.$refs.calendar.$el).fullCalendar('tomorrow');
          $(this.$refs.calendar.$el).fullCalendar('render');
          */
        })
      }
    },
    calendar_source_view_settings: {
      handler( settings_new, settings_old ) {
        console.log("[fullcalendar] source view settings changed - rerender events");
        // Always update (even though sometimes it's not necessary)
        const calendarElement = $(this.$refs.calendar.$el);
        calendarElement.fullCalendar('rerenderEvents');
      },
      deep: true
    }
  },
  mounted() {
    // trigger optimizer
    /* Add event listener that listens to resizing of the browser window */
    this.resizeListener = () => {
      if ( this.$route.name === 'calendar' ) {
        this.fitCalendarToPage();
      }
    }
    window.addEventListener('resize', this.resizeListener);
    this.fitCalendarToPage();
  },
  beforeDestroy() {
    if ( this.resizeListener ) {
      window.removeEventListener('resize', this.resizeListener)
    }
  },
  computed: {
    ...mapGetters('calendar',[
      "calendar_view_settings",
      "calendar_source_view_settings",
      "get_tsc_selected",
      "get_goal_selected",
      "get_effort_selected",
      "user_timeline_events",
      "optimizer_timeline_events",
      "flattened_timeslots"
    ]),
    // ...mapGetters("goal", [
      // "effort_by_effort_id",
      // "effort_list_all"
    // ]),
    ...mapGetters("user", [
      // "userData",
      "user_get_timezone"
    ]),
    ...mapGetters("optimizer", [
      'masked_optimizer_results',
      'optimization_running'
    ]),
    ...mapGetters("timeslots", [
      'get_timeslot_flat_cache'
    ]),

    ...mapState({
      optimizer_auto_trigger: state => state.optimizer.optimizer_auto_trigger
    }),

    timeslot_collection_list() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },

    calendar_loading_text() {
      if (this.optimization_running) {
        return "Goalpilot's Artificial Intelligence is calculating the best plan"
      } else {
        return ''
      }
    },

    calendar_config() {
      /* Important Info: No reactivity here. Fullcalendar won't update if the
         config changes after initial render. This means changing any parameters
         won't have any effect on the calendar, we need to sync the calendar
         state through calendarElement.fullcalendar API manually! */

      // TODO: move to created, because no reactiviy anyways
      // let localTime = moment.tz(this.$models.userSettings.getters.user_get_timezone)
      // let localDatetime = moment([localTime.year(),localTime.month(),localTime.day() + 2, localTime.hour(),localTime.minute(),localTime.second()])

      /* TODO: check if now indicator is updated, when user timezone is changed */

      return {
        // see: https://fullcalendar.io/docs
        defaultView: this.calendar_view_settings.view,
        visibleRange: {
          start: this.calendar_view_settings.visible_range.from_date.toFullCalendarV3(),
          end:   this.calendar_view_settings.visible_range.to_date.toFullCalendarV3(),
        },
        minTime: this.calendar_view_settings.visible_time.min_time + ':00:00',
        maxTime: this.calendar_view_settings.visible_time.max_time + ':00:00',
        slotDuration: this.calendar_view_settings.timeslotDuration,
        businessHours: {
          // days of week. an array of zero-based day of week integers (0=Sunday)
          dow: [ 1, 2, 3, 4, 5 ], // Monday - Friday
          start: '8:00',
          end: '18:00',
        },
        allDaySlot: false, // TODO: Disable as long as everything is implmented
        editable: true,
        selectable: true,
        header: false,
        columnHeader: true,
        nowIndicator: true,
        height: this.height,
        themeSystem: 'bootstrap4',
        columnHeaderHtml: null,
        scrollTime: moment.currentTime().toFullCalendarV3().format("HH:00:00"),
        /* TODO: Setting firstDay leads to a vuex store mutation.
                 This is because it modifies _week.dow (when localeData is reactive)*/
        // firstDay: 1,
        /*validRange: (nowDate) => {
          return { start: null, end: null };
        },*/
        eventAfterRender: (...args) => this.eventAfterRender(...args),
        eventAfterAllRender: (view) => {
          // console.log("eventAfterAllRender", view);
        }
        // timezoneParam: this.$models.userSettings.getters.user_get_timezone, // Does it work? -> YES. deactivated for now
        // now: localDatetime, // If we set now here, then it won't update
      }
    },

    user_events_and_optimizer_events_merged() {

      console.log("[fullcalendar] user_events_and_optimizer_events_merged - rerender events");

      let mergedEvents = [];
      /*if (this.optimization_running) {
        return []
      } else {*/
        // TOOD: Move all to store?
        // TODO: filter all or filter first?
        // TODO: more effective way to merge the arrays
        if ( this.calendar_source_view_settings.user ) {
          mergedEvents = mergedEvents.concat( this.user_timeline_events );
        }

        if ( this.calendar_source_view_settings.optimizer ) {
          mergedEvents = mergedEvents.concat( this.optimizer_timeline_events );
        }

        if ( this.calendar_source_view_settings.tsc ) {
          //mergedEvents = mergedEvents.concat( this.flattened_timeslots );
          mergedEvents = mergedEvents.concat( this.flattened_timeslots_new );
          //console.log(' this.flattened_timeslots_new',  this.flattened_timeslots_new)
        }

        mergedEvents.forEach(item => {
          item['devStart'] = item.start.format()
          item['devEnd'] = item.end.format()
        })

        //console.log("*** DAYPLAN: user_events_and_optimizer_events_merged", mergedEvents);
        return mergedEvents;
      //}
    },
    flattened_timeslots_new() {

      let tscData = {}

      this.timeslot_collection_list.forEach((tsc) => {
        tscData[tsc.$id] =  {
          name: tsc.$state.name,
          color: tsc.$state.color
        }
      })

      let visibleRangeFrom = this.calendar_view_settings.visible_range.from_date.toFullCalendarV3().startOf('day')
      let visibleRangeEnd =  this.calendar_view_settings.visible_range.to_date.toFullCalendarV3().endOf('day')
      let flattened_timeslots_new = []
      Object.keys(this.get_timeslot_flat_cache).forEach(tscId => {
        let event_data = this.get_timeslot_flat_cache[tscId].event_data
        let nrElements = event_data.length
        for (let i = 0; i < nrElements; i++) {
          let event = event_data[i]
          flattened_timeslots_new.push({
            start: moment(1000 * event.from),
            end: moment(1000 * event.to),
            devStart: moment(1000 * event.from).format(),
            devEnd: moment(1000 * event.to).format(),
            className: 'fc-timeslot',
            title: tscData[tscId].name,
            color: tscData[tscId].color,
            allDay: false,
            data: {
              source: 'TSC',
              duration: (event.to - event.from) / 60
            }
          })
        }
      })
      //console.log('timeslot_collection_list from', visibleRangeFrom, ' to',  visibleRangeEnd)
      return flattened_timeslots_new.filter(event => event.start >= visibleRangeFrom && event.end <= visibleRangeEnd)

    }
  },
  methods: {
    ...mapActions('calendar', [
      'calendar_delete_event',
      'calendar_create_event',
      'calendar_update_event',
    ]),

    ...mapMutations('optimizer', [
      'MASK_EVENT_ID',
      'UNMASK_EVENT_ID'
    ]),

    eventRender(event, element) {
      // console.log("eventRender", event._id, event.id);

      if ( event.data && event.data.source === 'OPTIMIZER-LOCKED' ) {
        /* If we want to make sure, that we only allow unlocking on events, that
          were added by the optimizer recently enough so that there still is an
          existing masked event, we should check state.optimizer.masked_event_ids
          if we still have an unlocked optimizer event in the store.
          This will change as soon as all optimizer events are stored in RTDB.
        */
        element.append(`
          <span class='calendar-btn calendar-unlockbtn' title='Unlock this event again'></span>
        `);
        element.find(".calendar-unlockbtn").click(() => {
          // this.onUnlockEvent(event)
          console.log("onUnlockEvent - TODO")
        });
      }
      if ( event.data && event.data.source === 'OPTIMIZER' ) {
        element.append(`
          <span class='calendar-icon'></span>
          <span class='calendar-btn calendar-lockbtn' title='Lock this event'></span>
        `);
        element.find(".calendar-lockbtn").click(() => {
          // this.onLockEvent(event, false)
          console.log("onLockEvent - TODO")
        });
      }

      if ( event.data && event.data.source === 'TSC' ) {

        if ( ENABLE_PRE_RENDERED_POPOVERS ) {
          // We might have a problem here when id's change all the time
          console.log("Adding Popover", event._id);
          this.addCalendarPopover( event._id, element, event );
        }
      }
    },

    eventAfterRender(event, element) {
      // console.log("eventAfterRender", event._id, event.id);

      let hasSessionEvent = this.calendar_source_view_settings.user ||
                            this.calendar_source_view_settings.optimizer;

      let hasTimeslots = this.calendar_source_view_settings.tsc;

      if ( hasTimeslots && !hasSessionEvent ) {
        /* Do not resize when only timeslots are shown */
        return;
      }

      if ( hasSessionEvent && !hasTimeslots ) {
        /* Do not resize when only sessions are shown */
        return;
      }

      /* Should we stack TSC when shown on side? */
      const TSC_ALIGN_LEFT = this.calendar_source_view_settings._stacking;

      /* IDEE: 2 Columns => 1 = TSCs, 2 = DELETED */
      const TWO_COLUMN_LAYOUT = true;

      if ( event.data && event.data.source === 'TSC' ) {
        let currentLeft = parseFloat( element.css('left') );
        let currentWidth = parseFloat( element.css('width') );

        if ( TSC_ALIGN_LEFT ) {
          currentLeft = 0;
          currentWidth = 20;
          if ( TWO_COLUMN_LAYOUT ) {
            const W1 = 20 * (2 / 3);
            currentLeft = !event.data.deleted ? 0 : W1;
            currentWidth = !event.data.deleted ? W1 : (20 - W1);
          }
        } else {
          currentLeft = Math.min( currentLeft / 10, 7.8 );
          currentWidth = 20;
        }

        element.css('left', currentLeft + '%');
        element.css('width', currentWidth + '%');
        element.addClass('fc-collapsed');
      } else {
        element.css('left',  TSC_ALIGN_LEFT ? '20%' : '27.8%');
        element.css('width', TSC_ALIGN_LEFT ? '80%' : '72.2%');
      }
    },

    eventDestroy( event ) {
      // console.log("eventDestroy", event._id);
      if ( event.data && event.data.source === 'TSC' ) {
        // if ( ENABLE_PRE_RENDERED_POPOVERS ) {}
        this.remCalendarPopover( event._id );
      }
    },

    onRender(view, element) {
      // console.log("onRender");
      this.$refs.calendarTopBar.setTitleString( view );
    },

    onEventMouseOver(event, jqueryEvent, view) {
      // console.log("onEventMouseOver", event, jqueryEvent, view);

      /* Use only one popover and recycle it - we can render on the fly! */
      if ( event.data && ENABLE_POPOVERS_FOR_SOURCE.includes(event.data.source) ) {
        let element = jqueryEvent.currentTarget;
        this.addCalendarPopover( event._id, element, event );
      }
    },

    onEventMouseOut(event) {
      // console.log("onEventMouseOut", event);
      this.remCalendarPopover( event._id );
    },

    /* ========================================= EVENTS ===================== */

    _delegateEvent( source, method, ...args ) {

      let sessionMethod, tscMethod;

      switch ( method ) {
        case 'SELECT':
        sessionMethod = this.onSessionSelect;
        tscMethod = this.onTimeslotSelect;
        break;

        case 'CREATE':
        sessionMethod = this.onSessionCreate;
        tscMethod = this.onTimeslotCreate;
        break;

        case 'RESIZE':
        sessionMethod = this.onSessionResize;
        tscMethod = this.onTimeslotResize;
        break;

        default: throw new Error('Unknown method <' + method + '>')
      }

      switch ( source ) {
        case 'USER':
        case 'OPTIMIZER':
        case 'OPTIMIZER-LOCKED':
        return sessionMethod(...args);

        case 'TSC':
        return tscMethod(...args);

        default: throw new Error('Unknown event source', event.data.source)
      }
    },

    onEventSelect(event, jsEvent, view) {
      // console.log("::onEventSelect", event, jsEvent, view);
      this._delegateEvent( event.data.source, 'SELECT', event );
    },

    onEventCreate(event) {
      // TODO: Check store what we have currently selected
      console.log("::onEventCreate", event, this.get_tsc_selected);

      if ( this.get_tsc_selected === null ) {
        this._delegateEvent( 'USER', 'CREATE', event );
      } else {
        this._delegateEvent( 'TSC', 'CREATE', event );
      }
    },

    onEventResize(event) {
      // console.log("::onEventResize", event);
      this._delegateEvent( event.data.source, 'RESIZE', event );
    },

    /* ========================================= SESSIONS =================== */

    onSessionSelect(event) {
      if ( !event ) {
        console.warn("Invalid event", event);
        return
      }

      let modal_data = Object.assign({}, event.data);

      /* TODO: Sometimes we will get a moment object, that already has a timezone
               set. This depends on whether we moved the event before clicking
               or not. This is very confusing and should be debugged. */

      // DELME: let start = event.start.utcOffset() === 0
      // DELME:    ? convert_calendartime_to_localMomentObj( event.start, this.$models.userSettings.getters.user_get_timezone )
      // DELME:    : event.start.clone();
      // DELME: let end = event.end.utcOffset() === 0
      // DELME:    ? convert_calendartime_to_localMomentObj( event.end, this.$models.userSettings.getters.user_get_timezone )
      // DELME:    : event.end.clone();

      let start = event.start.utcOffset() === 0
         ? moment.fromFullCalendarV3( event.start )
         : event.start.clone();
      let end = event.end.utcOffset() === 0
         ? moment.fromFullCalendarV3( event.end )
         : event.end.clone();

      // TODO: This is how it should be
      // It depends on where the event comes from

      // let start = moment.fromFullCalendarV3( event.start );
      // let end = moment.fromFullCalendarV3( event.end );

      console.log("TODO SESSION SELECT", start, end, modal_data)

      /*
      this.$root.showUpdateModal('session', {
        title:              event.title || '',
        eventId:            event.id,
        commitmentId:       modal_data.commitmentId,
        seqItemId:          modal_data.seqItemId,
        isOptimizerEvent:   ( event.data.source === 'OPTIMIZER' ),
        start:              start,
        end:                end,
        ...modal_data
      }).then(({ action, data }) => {

        if ( action === 'save' ) {
          if ( data.lockSession === true ) {
            this.onLockEvent(data.event, true)
          } else {
            this.calendar_update_event({
              eventId: data.eventId,
              eventData: {
                title:        data.title,
                start:        data.start,
                end:          data.end,
                tscId:        data.tscId,
                goalId:       data.goalId,
                commitmentId: data.commitmentId, // TODO: Map 1:1
                seqItemId:    data.seqItemId
              }
            }).then(this.onTriggerAutoOptimization);
          }
        }
        if ( action === 'delete' ) {
          console.log("Deleting event", data);
          this.calendar_delete_event({
            id: data.id
          }).then(this.onTriggerAutoOptimization);
        }
      });
      */
    },

    onSessionCreate(event) {

      if ( event.allDay ) {
        console.log("onSessionCreate -> all day", event.start.format());
        throw new Error("NOT IMPLEMENTED");

      } else {

        console.log("TODO - Ask which TSC or create (new) session type")

        /*
        console.log("onSessionCreate -> from, to, id",
          event.start.format('LLLL'),
          event.end.format('LLLL') );

        // INFO: Why is this conversion not done in the store?
        //       Because this is a correction of a moment object coming from
        //       fullcallendar and thus this is very specific to how fullcalendar
        //       handles moment objects. Only conversion that always apply, should
        //       be done in the store.
        // DELME: let start = convert_calendartime_to_localMomentObj( event.start, this.$models.userSettings.getters.user_get_timezone )
        // DELME: let end = convert_calendartime_to_localMomentObj( event.end, this.$models.userSettings.getters.user_get_timezone )
        // ^ not check for utc offset here!

        let start = moment.fromFullCalendarV3( event.start );
        let end = moment.fromFullCalendarV3( event.end );

        // console.log('event.start', event.start,'this.userData.settings.timezone', this.userData.settings.timezone, this.$models.userSettings.getters.user_get_timezone)
        let modalData = {
          title: event.title || '',
          start: start,
          end:   end,
          preselected_goal: this.get_goal_selected,
          preselected_effort: this.get_effort_selected
        };

        this.$root.showNewModal('session', modalData).then(({ action, data }) => {
          // console.log("GOT result", data);
          if ( action === 'save' ) {
            this.calendar_create_event({
              name:    data.title,
              payload: data
            }).then(this.onTriggerAutoOptimization);

            $(this.$refs.calendar.$el).fullCalendar('unselect'); // TODO: Required?
          }
        })
        */
      }
    },

    onSessionResize(event) {
      console.log('entered onSessionResize()', moment.tz(event.start,this.$models.userSettings.getters.user_get_timezone), moment.tz(event.end,this.$models.userSettings.getters.user_get_timezone))
      if ( event.allDay ) {
        console.log("onSessionResize allDay", event._id, event.start.format());
        throw new Error("NOT IMPLEMENTED");

      } else {
        let tscData = event.data;
        console.log("onSessionResize", event, tscData, event.start.format(), event.end.format());

        console.log("TODO - Resize event")

        // TODO: Throttle updates. We don't need to send every update immediately
        //       Maybe an event is moved a few times. We only need to send the
        //       last update! => We should do a 'per by' throttling.

        // INFO: Why is this conversion not done in the store?
        //       Because this is a correction of a moment object coming from
        //       fullcallendar and thus this is very specific to how fullcalendar
        //       handles moment objects. Only conversion that always apply, should
        //       be done in the store.

        // DELME: let start = convert_calendartime_to_localMomentObj( event.start, this.$models.userSettings.getters.user_get_timezone )
        // DELME: let end = convert_calendartime_to_localMomentObj( event.end, this.$models.userSettings.getters.user_get_timezone )
        // ^ no utc check here

        /*
        let start = moment.fromFullCalendarV3( event.start );
        let end = moment.fromFullCalendarV3( event.end );

        const isOptimizerSuggestion = ( tscData.source === 'OPTIMIZER' );
        if ( isOptimizerSuggestion ) {
          this.calendar_create_event({
            name:  event.title,
            payload: {
              start:        start,
              end:          end,
              tscId:        event.data.tscId,
              goalId:       event.data.goalId,
              commitmentId: event.data.commitmentId,
              seqItemId:    event.data.seqItemId,
              originIsOptimizer: true
            }
          }).then((new_id) => {
            this.MASK_EVENT_ID({ pseudoId: event.id, id: new_id });
            // INFO: This is very tricky! The user moved a session, but how do we know
            //       in the next optimization round, that we should not plan here

            this.onTriggerAutoOptimization();
          });
        } else {
          this.calendar_update_event({
            eventId: event.id,
            eventData: {
              start: start,
              end:   end
            }
          }).then(this.onTriggerAutoOptimization);
        }
        */
      }
    },

    /* ---------------------------------------------------------------------- */

    /*
    onLockEvent(event, openModalAfterLocking) {
      console.log("onLockEvent", event, event.start.format());

      // DELME: let start = convert_calendartime_to_localMomentObj( event.start, this.$models.userSettings.getters.user_get_timezone )
      // DELME: let end = convert_calendartime_to_localMomentObj( event.end, this.$models.userSettings.getters.user_get_timezone )
      // ^ no utc check here
      let start = moment.fromFullCalendarV3( event.start );
      let end = moment.fromFullCalendarV3( event.end );

      if ( event.start.utcOffset() !== 0 ) {
        // This is the case, when event comes from optimizer and is now locked
        // via Lock-Button
        start = event.start.clone();
        end = event.end.clone();
      } else {
        console.log("**** WE WILL GET A TIMESTMAP HERE THAT ALREADY HAS A TZ ****");
        console.log("**** IF YOU SEE THIS - WE HAVE TO DEBUG HERE ****");
      }

      // INFO: Delete item from full-calendar before we know that it is deleted from the DB
      const REMOVE_EVENT_BEFORE_PROMISE = true;
      if ( REMOVE_EVENT_BEFORE_PROMISE ) {
        const calendarElement = $(this.$refs.calendar.$el);
        calendarElement.fullCalendar('removeEvents', event.id);
      }

      this.calendar_create_event({
        name:  event.title, // Function?
        payload: {
          start:        start,
          end:          end,
          tscId:        event.data.tscId,
          commitmentId: event.data.commitmentId,
          goalId:       event.data.goalId,
          seqItemId:    event.data.seqItemId,
          originIsOptimizer: true
        }
        // TODO: How to I know that this replaces optimizer event X?
      }).then((new_id) => {
        console.log("Crete event done. Now masking", event.id, new_id);

        this.MASK_EVENT_ID({ pseudoId: event.id, id: new_id });

        if ( openModalAfterLocking ) {
          // Call onSessionSelect again with event data of new event!
          let newId = null; // PROBLEM: We dont know the id yet
          if ( newId ) {
            this.onSessionSelect(Object.assign({}, event, { id: newId }));
          }
        }
        //this.onTriggerAutoOptimization();
      });
    },

    onUnlockEvent(event) {
      console.log("onUnlockEvent", event);

      this.UNMASK_EVENT_ID(event.id);

      this.calendar_delete_event({
        id: event.id
      }).then(this.onTriggerAutoOptimization); // .then(this.onTriggerAutoOptimization);

      $(this.$refs.calendar.$el).fullCalendar('unselect'); // TODO: Required?
    },
    */

    /* ========================================= TIMESLOTS ================== */

    onTimeslotSelect(event) {
      if ( event ) {
        let modal_data = Object.assign({}, {
          ...event.data,
          previousTscId: event.data.tscId,
          override_timezone: null // TODO !!!
        });
        // this.modal_data = Object.assign({}, {
        //   id: event._id,
        //   className: event.className,
        //   title: event.title,
        //   start: event.start,
        //   tscId: event.className[0]
        // })
        this.$root.showModal('timeslot-details', {
          modal_data: modal_data
        }).then(() => {
          console.log('DONE MODAL TS DETAILS');
        })
      }
    },

    onTimeslotCreate(event) {

      if ( this.get_tsc_selected === null ) {
        // TODO: show nice modal
        alert('Please select a timeslot collection first.')
        $(this.$refs.calendar.$el).fullCalendar('unselect');
        return;
      }

      if ( event.allDay ) {
        console.log("onTimeslotCreate -> all day", event.start.format());
        throw new Error("NOT IMPLEMENTED");

      } else {
        console.log("onTimeslotCreate -> from, to, id",
          event.start.format('LLLL'),
          event.end.format('LLLL'),
          this.get_tsc_selected);

        this.$api.timeslot_collection_add_exception({
          timeslotCollectionId: this.get_tsc_selected, // this.timeslot_collection_list[0].id,
          exception: {
            type: 'INS',
            from:  moment.fromFullCalendarV3( event.start ),
            to:    moment.fromFullCalendarV3( event.end ),
          }
        }).then((e) => {
          $(this.$refs.calendar.$el).fullCalendar('unselect');

          this.onTriggerAutoOptimization();

          // this.$store.commit("timeslots/INCREASE_UPDATE_COUNT");
          // this.$nextTick(() => {
          //   $(this.$refs.calendar.$el).fullCalendar('unselect');
          //   $(this.$refs.calendar.$el).fullCalendar('refetchEvents')
          //   $(this.$refs.calendar.$el).fullCalendar('render');
          //   $(this.$refs.calendar.$el).fullCalendar('unselect');
          // })
          // setTimeout(() => {
          //   console.log("TT");
          //   $(this.$refs.calendar.$el).fullCalendar('unselect');
          //   $(this.$refs.calendar.$el).fullCalendar('refetchEvents')
          //   $(this.$refs.calendar.$el).fullCalendar('render');
          //   $(this.$refs.calendar.$el).fullCalendar('unselect');
          // }, 2000);
        })
      }
    },

    onTimeslotResize(event) {
      let promiseList = [];

      if ( event.allDay ) {
        console.log("onTimeslotResize allDay", event._id, event.start.format());
        throw new Error("NOT IMPLEMENTED");

      } else {
        let tscData = event.data;
        console.log("onTimeslotResize", tscData, event.start.format(), event.end.format());

        /* Did the user update a rule generated event or an INS-event? */
        if ( tscData.exception ) {

          promiseList.push( this.$api.timeslot_collection_update_exception({
            timeslotCollectionId: tscData.tscId,
            exceptionId: tscData.excId,
            newException: {
              from: moment.fromFullCalendarV3( event.start ), // TODO: Don't use ISO string
              to: moment.fromFullCalendarV3( event.end ) // TODO: Don't use ISO string
            }
          }) );

        } else {

          /* Feature: Remove DEL-exception when it is resized? */
          const REMOVE_DELETE_ON_RESIZE_DELETE = false;

          if ( tscData.deleted ) {
            /* The user is resizing a deleted event - now what? Let assume he
               wants to revert back to non deleted session but with update time.
               This means we have to delete the DEL-exception and create a new
               INS-exception. Alternatively we keep the DEL-exception, since the
               user should only see one session. */
            if ( REMOVE_DELETE_ON_RESIZE_DELETE ) {
              promiseList.push( this.$api.timeslot_collection_rem_exception({
                timeslotCollectionId: tscData.tscId,
                exceptionId: tscData.deleted_by
              }) );
            }

            promiseList.push( this.$api.timeslot_collection_add_exception({
              timeslotCollectionId: tscData.tscId,
              exception: {
                type: 'INS',
                from: moment.fromFullCalendarV3( event.start ),
                to:   moment.fromFullCalendarV3( event.end ),
              }
            }) )

            /* We're done, return */
            Promise.all(promiseList).then(this.onTriggerAutoOptimization);
            return;
          }

          /* There is currently two methods to update a rule generated event.
          both should work. */
          const RESIZE_METHOD = 'DEL-INS';

          /* The rule got changed that means we need to create a CHG exception */
          if ( RESIZE_METHOD === 'CHG') {
            promiseList.push( this.$api.timeslot_collection_add_exception({
              timeslotCollectionId: tscData.tscId,
              exception: {
                type:     'CHG',
                ref:      tscData.rule_origin_id,
                date:     moment.fromFullCalendarV3( event.start ), // remove?
                // new_from: event.start.format('HH:MM'),
                // new_to:   event.end.format('HH:MM'),
                // BESSER:
                new_from: moment.fromFullCalendarV3( event.start ),
                new_to: moment.fromFullCalendarV3( event.end ),
              }
            }) );
          }

          /* Alternatively create a DEL and INS exception */
          if ( RESIZE_METHOD === 'DEL-INS' ) {
            promiseList.push( this.$api.timeslot_collection_add_exception({
              timeslotCollectionId: tscData.tscId,
              exception: {
                type: 'DEL',
                ref:  tscData.rule_origin_id,
                // date: tscData.from.startOf('day').toISOString(true) // TODO !!!
                /* TWE: Unklar warum es nicht geht:
                  tscDate.from = "2019-01-03T00:00:00Z" - warum fehlt hier die TZ?
                   This also does not work with timezones */
                // date: event.start.clone().startOf('day').toISOString(true) // TEMPRORARY BUGFIX
                date: moment.fromFullCalendarV3( event.start.clone().startOf('day') ) // <<<< TESTEN !!!!
              }
            }) )
            promiseList.push( this.$api.timeslot_collection_add_exception({
              timeslotCollectionId: event.data.tscId,
              exception: {
                type: 'INS',
                from: moment.fromFullCalendarV3( event.start ),
                to:   moment.fromFullCalendarV3( event.end ),
              }
            }) );
          }
        }

        Promise.all(promiseList).then(this.onTriggerAutoOptimization).catch(e => {
          console.warn("One of the promises failed. No auto-trigger. Got error: ", e);
        });
      }
    },

    /* ====================================================================== */

    onTriggerAutoOptimization() {
      console.log("onTriggerAutoOptimization", this.optimizer_auto_trigger);
      if ( this.optimizer_auto_trigger ) {
        /* WORKAROUND: We need to wait until data is updated ...*/
        console.log("AUTO TRIGGER");
        this.$emit('auto-update')

        /*setTimeout(() => {
          // TODO: Throttle
          // TODO: Check if optimization is already in progress
          console.log("AUTO TRIGGER");
          this.$emit('auto-update')
        }, 500)*/
      }
    },

    fitCalendarToPage() {
      this.height = window.innerHeight - 110; // 50 /* top bar */ - 45 /* bottom bar */ - 130
      if ( this.$refs.calendar ) {
        const calendarElement = $(this.$refs.calendar.$el);
        calendarElement.fullCalendar('option', 'height', this.height);
      }
    },

    onSaveViewSettings(config) {
      // nothing to do
    },

    onTriggerCalendarEvent(action) {
      // nothing to do
    },
  },
  components: {
    FullCalendar,
    CalendarTopBar
  }
}
</script>

<style>
.calendar-icon {
  opacity: 1;
  background: url('/favicon.ico');
  background-size: contain;
  right: 18px;
  border-radius: 33%;
  z-index: 999;
  position: absolute;
  top: 1px;
  width: 15px;
  height: 15px;
  background-color: #fff;
  line-height: 16px;
}
.calendar-btn {
  z-index: 999;
  color: black;
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 13px;
  cursor: pointer;
  background-color: #fff;
  text-align: center;
  vertical-align: middle;
  line-height: 16px;
  border: 1px solid #0000008a;
}
.calendar-lockbtn {
}
.calendar-lockbtn::before {
  margin-left: 1px;
  content: "\01F513";
}
.calendar-lockbtn:hover::before {
  margin-left: 1px;
  content: "\01F512";
}
.calendar-unlockbtn {
  z-index: 999;
  position: absolute;
  top: 2px;
  right: 0;
  font-size: 13px;
}
.calendar-unlockbtn::before {
  margin-left: 1px;
  content: "\01F512";
}
.calendar-unlockbtn:hover::before {
  margin-left: 1px;
  content: "\01F513";
}

/* style events */
.fc-time-grid .fc-event-container {
  /* margin: 0; */
}
.fc-session-optimizer.fc-event,
.fc-session.fc-event {
  /* left: 25% !important; */
  /* width: 75% !important; */
}
.fc-timeslot.fc-event {
  /* TODO */
  /* left: 0% !important; */
  /* width: 25% !important; */
  border-radius: 0;
  border-left: none;
  border-right: none;
}
.fc-timeslot.fc-event.fc-no-stacking {
  left: 0% !important;
}
.fc-timeslot.fc-event.fc-deleted {
  --bg-color: #c5c5c5;
  --stripe-color: #b1b1b1;

  background:
 repeating-linear-gradient(
    45deg,
    var(--bg-color)     0,
    var(--bg-color)     4px,
    var(--stripe-color) 4px,
    var(--stripe-color) 8px
 );
}
.fc-helper.fc-event {
  border: 1px solid #aaaaaa; /* default BORDER color */
  opacity: 1;
}
.fc-helper.fc-event,
.fc-helper.fc-event-dot {
  background-color: #eeeeee; /* default BACKGROUND color */
}
.fc-helper .fc-content {
  color: black;
}
.progress-bar-caption {
  text-align: right;
  margin: 0 1.2em;
  margin-top: -3px;
  font-size: 9pt;
  font-weight: bold;
  display: block;
  line-height: 1.3em;
}

.tooltip {
  opacity: 1 !important;
}

.fc-timeslot {
}
.fc-collapsed.fc-allow-mouse-resize {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  opacity: 1;
}
.fc-collapsed {
  opacity: 1;
  /* border: 2px solid blue !important; */
}
.fc-collapsed .fc-content {
  /* hide content of event if collaped */
  display: none;
}
</style>
